// Delegation survives native cart section replacement. No automatic mutation retries.
(() => {
  let adding = false;
  // Trio mapping requires this handler; keep its native submit disabled without JS.
  document.querySelectorAll('[data-coffee-trio-submit]').forEach(button => {
    const select = button.form?.querySelector('[data-coffee-trio]');
    if (select && !select.disabled && select.options.length) button.disabled = false;
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-coffee-basket]')) return;
    event.preventDefault();
    if (adding || !form.reportValidity()) return;
    adding = true;
    const buttons = document.querySelectorAll('[data-coffee-basket] button');
    buttons.forEach(button => { button.disabled = true; });
    const status = form.querySelector('[data-coffee-status]');
    status.textContent = status.dataset.pending;
    const data = new FormData(form);
    const trio = form.querySelector('[data-coffee-trio]');
    const items = trio
      ? trio.value.split(',').filter(Boolean).map(id => ({ id: Number(id), quantity: 1 }))
      : [...form.querySelectorAll('select')].map((select, index) => ({
        id: Number(select.value), quantity: Number(data.get(`items[${index}][quantity]`))
      }));
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Cart update not confirmed');
      await response.json();
      window.location.assign(form.querySelector('[name="return_to"]').value);
    } catch {
      status.textContent = status.dataset.error;
      form.querySelector('[data-coffee-recovery]').hidden = false;
      // Keep this form disabled after an uncertain write, to avoid duplicate additions.
      buttons.forEach(button => { if (!form.contains(button)) button.disabled = false; });
      adding = false;
    }
  });
})();
